import React from "react";
import { Switch } from "@my-scoot/component-library-legacy";

const SectionVisibilityToggle = ({
  visible,
  disabled = false,
  onToggle,
  label = "Hide this section",
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw--mt-2 tw--mx-4 tw-py-1 tw-px-4 tw-mb-4 tw-bg-[#F3F3F3]">
      <span className="tw-text-[13px] tw-font-medium tw-text-gray-900">
        {label}
      </span>

      <Switch
        checked={!visible}
        disabled={disabled}
        onChange={onToggle}
        color="success"
        size="large"
      />
    </div>
  );
};

export default SectionVisibilityToggle;
